// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { constants } from "@stoneage/XDL/constants";
import { getCloudinaryUrl, TransformationsOptions } from "@stoneage/XDL/Utilities/cloudinary";
import { ImageSettingKey } from "@stoneage/XDL/types";

export interface GenerateCloudinaryUrlOptions extends TransformationsOptions {
    imageKey?: keyof typeof ImageSettingKey;
    disableFallbackImage?: boolean;
}

/**
 * Override this component to implement:
 * - Lazy loading feature: Images will be loaded when they are visible in viewports
 * - Responisve images using the picture element
 */
export function generateCloudinaryUrl(src?: string, options?: GenerateCloudinaryUrlOptions) {
    if (typeof window === "undefined") {
        return src;
    }
    const generalNotFoundImagePath = localStorage.getItem(constants.cookies.cloudinaryGlobalNotFoundImagePath);
    const notFoundCategoryImagePath =
        localStorage.getItem(constants.cookies.productMediumDefaultImagePath) ||
        localStorage.getItem(constants.cookies.productLargeDefaultImagePath) ||
        localStorage.getItem(constants.cookies.productSmallDefaultImagePath);
    const baseCloudinaryUrl = localStorage.getItem(constants.cookies.cloudinaryMediaRootPath) || "";

    const notFoundImagePath =
        options?.imageKey === ImageSettingKey.category
            ? notFoundCategoryImagePath || generalNotFoundImagePath
            : generalNotFoundImagePath;

    const url = getCloudinaryUrl(src, baseCloudinaryUrl, {
        width: options?.width,
    });

    if (options?.disableFallbackImage) {
        return url;
    }

    return url || notFoundImagePath;
}

export const getSEOProductImagePath = (src?: string, cloudinaryRootPath?: string, isCatalogImage?: boolean) => {
    if (typeof localStorage !== "undefined" && localStorage !== null) {
        if (src) {
            if (src.toLowerCase().indexOf("userfiles") > -1) {
                return window.location.hostname + src;
            }

            if (src.toLowerCase().indexOf("res.cloudinary") > -1) {
                return src;
            }
        }
        const globalNotFoundImagePath = localStorage.getItem(constants.cookies.cloudinaryGlobalNotFoundImagePath);
        const catalogNotFoundImagePath =
            localStorage.getItem(constants.cookies.productMediumDefaultImagePath) ||
            localStorage.getItem(constants.cookies.productLargeDefaultImagePath) ||
            localStorage.getItem(constants.cookies.productSmallDefaultImagePath);
        if (!src) {
            return isCatalogImage ? catalogNotFoundImagePath : globalNotFoundImagePath;
        }
        return cloudinaryRootPath + src;
    }
};
